<template>
  <v-sheet class="live-trade-card close-trade-card" color="rgba(255, 86, 127, 0.08)">
    <v-card-text class="trade px-0 pb-4 pt-2">
      <div class="d-flex align-start">
        <v-icon large color="#708AA7"> mdi-circle-small </v-icon>
        <v-spacer></v-spacer>
        <p class="ma-0">
          Closed Trades(Today)
          <span class="equity-text"
            :style="{ color: dashboardClosedTradesData?.totalProfit < 0 ? '#ff567f' : null }">Total Lot: {{
              formattedAllNumber(dashboardClosedTradesData?.totalVolume) }}</span>
        </p>
        <div class="circle-indicator" :class="{ 'loading': isLoading }">
          <v-icon v-if="!isLoading" class="ml-1 mb-0.5" size="medium" color="#708AA7" @click="refreshTrades"
            title="Refresh Closed Trades">
            mdi-refresh
          </v-icon>
          <v-icon v-else class="rotating ml-2 mb-0.5" size="medium" color="#708AA7">mdi-loading</v-icon>
        </div>
      </div>
      <v-spacer></v-spacer>
      <!-- <router-link class="links" to="/closed-trades">See All ></router-link> -->
    </v-card-text>
    <v-card-text class="pa-0 liveTradeChart">
      <p>
        <CloseTradeChart></CloseTradeChart>
      </p>
    </v-card-text>
    <v-card-text class="pl-3 pr-0 pb-4 trade">
      <span class="number closed-number">{{ formattedAllNumber(dashboardClosedTradesData?.total) }}</span>
      <v-spacer></v-spacer>
      <span class="equity">Profit: <strong>{{ formattedAllNumber(dashboardClosedTradesData?.totalProfit) }}
          USD</strong></span>
    </v-card-text>
  </v-sheet>
</template>

<script>
import { mapActions, mapState } from "vuex";
import { CLOSEDTRADES__ACTIONS } from "@/store/action-types";
import CloseTradeChart from "./CloseTradeChart.vue";
import { formatNumber } from "@/_helpers/formatNumber";

export default {
  components: { CloseTradeChart },
  data: () => ({
    isLoading: false
  }),
  computed: {
    ...mapState("closedtrades", ["dashboardClosedTradesData"]),
  },
  methods: {
    ...mapActions("closedtrades", [CLOSEDTRADES__ACTIONS.DASHBOARDCLOSEDTRADES]),

    formattedAllNumber(num) {
      return formatNumber(num || 0);
    },

    async refreshTrades() {
      if (this.isLoading) return;

      this.isLoading = true;
      try {
        await this[CLOSEDTRADES__ACTIONS.DASHBOARDCLOSEDTRADES]();
      } finally {
        setTimeout(() => {
          this.isLoading = false;
        }, 500);
      }
    }
  },

  async created() {
    await this[CLOSEDTRADES__ACTIONS.DASHBOARDCLOSEDTRADES]();
  },
};
</script>


<style>
@keyframes spin {
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
}

.rotating {
  animation: spin 1s linear infinite;
}

.circle-indicator {
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>